// --- Theme initialization ---
// Lee la misma key que usa header.js (bungalionDark)
// y agrega class 'dark' para que Tailwind dark: funcione
document.addEventListener("DOMContentLoaded", function () {
    var appDiv = document.getElementById("app");
    if (!appDiv) return;
    var isDark = (localStorage.getItem("bungalionDark") || "false") === "true";
    appDiv.classList.remove("theme--dark", "theme--light", "dark");
    appDiv.classList.add(isDark ? "theme--dark" : "theme--light");
    if (isDark) appDiv.classList.add("dark");
});
// Import utils.js first to ensure global functions are available
import "../src/js/utils.js";

// Deshabilitar validación jQuery para #contact_form (prevenir conflicto con SweetAlert2)
import "../src/js/disable-contact-form-validation.js";

// Import PQRS modular files
import "../src/js/pqr/pqrs-form.js";
import "../src/js/pqr/pqrs-submit.js";

// Then import all other JS files
import.meta.glob("../src/js/*.js", { eager: true });

// ==============================
// SWEETALERT2 GLOBAL
// ==============================
import Swal from "sweetalert2";
window.Swal = Swal; // Ahora puedes usar Swal.fire() en cualquier parte

// Sistema de Alertas Globales (debe cargarse después de Swal)
import "./global-alerts.js";

// Sistema de Requisitos Modal (para todos los trámites)
import "./requisitos-alerts.js";

// ==============================
// ALPINE.JS - Configuración Global
// ==============================
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

// Registrar plugin Collapse
Alpine.plugin(collapse);

// Registrar Alpine globalmente ANTES de importar componentes
window.Alpine = Alpine;

// ==============================
// ESTRATEGIA DE CARGA: Servicios públicos (páginas frecuentes)
// Se incluyen en el bundle principal porque:
// 1. Son pequeños (~5KB cada uno)
// 2. Se usan frecuentemente
// 3. Evita problemas de timing con Alpine
// ==============================
import { tarifasPage } from "../src/js/servicios/tarifas-page";
import { tramitesPage } from "../src/js/servicios/tramites-page";
import { infraccionesPage } from "../src/js/servicios/infracciones-page";

// ==============================
// COMPONENTES DE TRÁMITES
// ==============================

// Componente unificado para todos los trámites (salida, individualizar, impugnación)
import { tramiteForm } from './components/tramite-form.js';
window.tramiteForm = tramiteForm;

// Registrar componentes Alpine
document.addEventListener("alpine:init", () => {
    Alpine.data("tarifasPage", tarifasPage);
    Alpine.data("tramitesPage", tramitesPage);
    Alpine.data("infraccionesPage", infraccionesPage);
    Alpine.data("tramiteForm", tramiteForm); // Componente unificado
});

// Iniciar Alpine
Alpine.start();

//console.log("✅ Alpine.js inicializado con componentes de servicios públicos");

/*###PLUGINS LOCALES###*/
// Importar Material Design Icons
import "@mdi/font/css/materialdesignicons.min.css";

// Importar Select2
import "select2";
import "select2/dist/css/select2.min.css";

// Importar Choices.js
import Choices from "choices.js";
import "choices.js/public/assets/styles/choices.min.css";
window.Choices = Choices;

// Importar Dropzone
import { Dropzone } from "dropzone";
import "dropzone/dist/dropzone.css";

// Sistema de Requisitos Modal (para todos los trámites)
import "./requisitos-alerts.js";

// Importar Quill
import Quill from "quill";
import "quill/dist/quill.snow.css";

/*###CROPPER.JS###*/
// Importar Cropper.js para recorte de imágenes
import Cropper from "cropperjs";

// Configurar Dropzone globalmente
Dropzone.autoDiscover = false;

// Hacer Dropzone, Quill y Cropper disponibles globalmente
window.Dropzone = Dropzone;
window.Quill = Quill;

/**
 * Inicializar Quill Editor para contenido de artículos
 * @author carlos rodriguez
 * @since 2025
 */
window.initializeQuillEditor = function (selector, options = {}) {
    const defaultOptions = {
        theme: "snow",
        placeholder: "Escriba el contenido del artículo aquí...",
        modules: {
            toolbar: {
                container: [
                    [{ header: [1, 2, 3, false] }],
                    ["bold", "italic", "underline", "strike"],
                    [{ color: [] }, { background: [] }],
                    [{ align: [] }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    ["blockquote", "code-block"],
                    ["link", "image"],
                    ["clean"],
                ],
                handlers: {
                    image: function () {
                        window.quillImageHandler(this);
                    },
                },
            },
        },
    };

    const config = { ...defaultOptions, ...options };
    const element = document.querySelector(selector);

    if (element) {
        //console.log(`🖋️ Inicializando Quill Editor para: ${selector}`);

        // Crear el editor
        const quill = new Quill(element, config);

        // Sincronizar con el textarea original para el formulario
        const hiddenInput = document.querySelector(`${selector}_hidden`);
        if (hiddenInput) {
            quill.on("text-change", function () {
                hiddenInput.value = quill.root.innerHTML;
            });
        }

        return quill;
    } else {
        //console.warn(`⚠️ Elemento ${selector} no encontrado para Quill Editor`);
        return null;
    }
};

/**
 * Manejador personalizado de imágenes para Quill
 */
window.quillImageHandler = function (quill) {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = function () {
        const file = input.files[0];
        if (file) {
            // Mostrar preview y opción de recorte
            const reader = new FileReader();
            reader.onload = function (e) {
                // Crear modal para preview y recorte
                showQuillImagePreview(e.target.result, file, quill);
            };
            reader.readAsDataURL(file);
        }
    };
};

/**
 * Inicializar Dropzone para gestor de contenidos
 * @author carlos rodriguez
 * @since 2025
 */

// Array global para rastrear imágenes temporales
window.uploadedTempImages = window.uploadedTempImages || [];
window.initializeGestorDropzone = function () {
    $(".gestor-dropzone").each(function () {
        const $dropzone = $(this);

        // Evitar inicializar dos veces el mismo elemento
        if ($dropzone.data("dropzone-instance")) return;

        const fileName = $dropzone.data("file_name");
        const acceptedFiles = $dropzone.data("accepted_files");
        const maxFiles = $dropzone.data("max_files") || 1;
        const maxFilesize = $dropzone.data("max_filesize") || 3;
        const uploadUrl = $dropzone.data("url");

        const dropzoneInstance = new Dropzone($dropzone[0], {
            url: uploadUrl,
            method: "post",
            paramName: "file",
            maxFilesize,
            maxFiles,
            acceptedFiles,
            clickable: true,
            addRemoveLinks: true,
            dictDefaultMessage: "Haz click o arrastra una imagen aquí",
            dictRemoveFile: "Eliminar",
            dictFileTooBig: `Archivo muy grande ({{filesize}}MB). Máximo: ${maxFilesize}MB.`,
            dictInvalidFileType: "Solo imágenes permitidas.",
            dictMaxFilesExceeded: `Máximo ${maxFiles} archivo${
                maxFiles > 1 ? "s" : ""
            }.`,
            thumbnailWidth: 600,
            thumbnailHeight: 400,
            thumbnailMethod: "contain",
            resizeWidth: 1200,
            resizeHeight: 900,
            resizeQuality: 0.9,
            previewTemplate: `
                <div class="dz-preview dz-file-preview">
                    <div class="dz-image">
                        <img data-dz-thumbnail alt="Preview" />
                    </div>
                    <div class="dz-details">
                        <div class="dz-filename"><span data-dz-name></span></div>
                        <div class="dz-size"><span data-dz-size></span></div>
                    </div>
          
                </div>
            `,
            headers: {
                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
            },
            init: function () {
                const self = this;

                // Cuando se agrega archivo
                this.on("addedfile", function (file) {
                    // Deshabilitar solo el área de drop, no los botones
                    this.options.clickable = false;
                    $dropzone.removeClass("dz-clickable");

                    // Configurar click en imagen después de un pequeño delay
                    setTimeout(() => {
                        const preview = file.previewElement;
                        const dzImage = preview.querySelector(".dz-image");
                        const removeBtn = preview.querySelector(".dz-remove");
                        if (dzImage) {
                            dzImage.style.cursor = "pointer";
                            dzImage.onclick = (e) => {
                                e.stopPropagation();
                                if (this.hiddenFileInput) {
                                    this.hiddenFileInput.click();
                                }
                            };
                        }

                        // Asegurar que el botón eliminar funcione
                        if (removeBtn) {
                            removeBtn.onclick = function (e) {
                                e.preventDefault();
                                e.stopPropagation();
                                self.removeFile(file);
                            };
                        }
                    }, 100);
                });

                // Cuando se elimina archivo
                this.on("removedfile", function (file) {
                    // Reactivar área de drop
                    self.options.clickable = $dropzone[0];
                    $dropzone.addClass("dz-clickable");

                    // Eliminar imagen temporal del servidor inmediatamente
                    const removedImg = window.uploadedTempImages.find(
                        (img) => img.field === fileName
                    );
                    if (removedImg && removedImg.filename) {
                        deleteTempImage(removedImg.filename);
                    }

                    // Limpiar campo
                    $(`#${fileName}`).val("");

                    // Limpiar de array temporal
                    window.uploadedTempImages =
                        window.uploadedTempImages.filter(
                            (img) => img.field !== fileName
                        );
                });

                // Subida exitosa
                this.on("success", function (file, response) {
                    if (response && response.success) {
                        // Si había una imagen previa temporal, eliminarla del server
                        const prevImg = window.uploadedTempImages.find(
                            (img) => img.field === fileName
                        );
                        if (prevImg && prevImg.filename && prevImg.filename !== response.filename) {
                            deleteTempImage(prevImg.filename);
                        }

                        $(`#${fileName}`).val(response.filename);

                        const existingIndex =
                            window.uploadedTempImages.findIndex(
                                (img) => img.field === fileName
                            );

                        const imageData = {
                            filename: response.filename,
                            field: fileName,
                            uploaded: true,
                        };

                        if (existingIndex >= 0) {
                            window.uploadedTempImages[existingIndex] =
                                imageData;
                        } else {
                            window.uploadedTempImages.push(imageData);
                        }
                    }
                });

                // Error en subida
                this.on("error", function (file, errorMessage) {
                    const message =
                        typeof errorMessage === "object"
                            ? errorMessage.message || "Error desconocido"
                            : errorMessage;
                    window.Swal.fire({
                        icon: 'error',
                        title: 'Error al subir imagen',
                        text: message,
                        confirmButtonText: 'Cerrar'
                    });

                    // Reactivar área en caso de error
                    self.options.clickable = $dropzone[0];
                    $dropzone.addClass("dz-clickable");
                });

                // Máximo de archivos excedido
                this.on("maxfilesexceeded", function (file) {
                    this.removeFile(file);
                    window.Swal.fire({
                        icon: 'warning',
                        title: 'Límite alcanzado',
                        text: `Solo se permite${maxFiles > 1 ? 'n' : ''} ${maxFiles} archivo${maxFiles > 1 ? 's' : ''}.`,
                        confirmButtonText: 'Entendido'
                    });
                });
            },
        });

        // Guardar referencia
        $dropzone.data("dropzone-instance", dropzoneInstance);
    });
};
// Función para eliminar imagen temporal del storage
function deleteTempImage(filename) {
    if (!filename) return;

    $.ajax({
        url: "/gestor-contenido/delete-temp-image",
        method: "POST",
        data: {
            filename: filename,
            _token: $('meta[name="csrf-token"]').attr("content"),
        },
        success: function (response) {
            if (response.success) {
                //console.log(`🗑️ Imagen temporal eliminada: ${filename}`);
            }
        },
        error: function () {
            //console.warn(`⚠️ No se pudo eliminar imagen temporal: ${filename}`);
        },
    });
}

// Sistema robusto de limpieza automática de imágenes temporales
$(window).on("beforeunload unload pagehide", function (e) {
    // Intentar limpieza inmediata si hay imágenes temporales
    if (window.uploadedTempImages && window.uploadedTempImages.length > 0) {
        const formSubmitted =
            sessionStorage.getItem("formSubmitted") === "true";
        if (!formSubmitted) {
            //console.log(
            //     "🧹 LIMPIEZA AUTOMÁTICA ACTIVADA - Imágenes:",
            //     window.uploadedTempImages.length
            // );

            // Guardar en localStorage para limpieza posterior si falla
            localStorage.setItem(
                "pendingCleanup",
                JSON.stringify({
                    images: window.uploadedTempImages.map(
                        (img) => img.filename
                    ),
                    timestamp: Date.now(),
                })
            );

            // Estrategia múltiple de limpieza
            window.uploadedTempImages.forEach((img) => {
                if (img.filename) {
                    // 1. Intentar sendBeacon primero
                    if (navigator.sendBeacon) {
                        const data = new FormData();
                        data.append("filename", img.filename);
                        data.append(
                            "_token",
                            $('meta[name="csrf-token"]').attr("content")
                        );
                        navigator.sendBeacon("/gestor-contenido/delete-temp-image", data);
                        //console.log(`📡 SendBeacon enviado: ${img.filename}`);
                    }

                    // 2. AJAX síncrono como backup
                    try {
                        $.ajax({
                            url: "/gestor-contenido/delete-temp-image",
                            method: "POST",
                            async: false, // CRÍTICO: síncrono para que no se cancele
                            timeout: 1000, // 1 segundo máximo
                            data: {
                                filename: img.filename,
                                _token: $('meta[name="csrf-token"]').attr(
                                    "content"
                                ),
                            },
                            success: function () {
                                //console.log(`✅ AJAX exitoso: ${img.filename}`);
                            },
                            error: function () {
                                //console.warn(`❌ AJAX falló: ${img.filename}`);
                            },
                        });
                    } catch (e) {
                        //console.warn(`⚠️ Error AJAX: ${img.filename}`, e);
                    }
                }
            });
        }
    }
});

// Limpieza al detectar cambio de página/navegación
$(document).on("click", "a[href], button", function (e) {
    const $this = $(this);
    const href = $this.attr("href");
    const text = $this.text().toLowerCase().trim();
    const formAction = $this.closest("form").attr("action");

    // SISTEMA UNIVERSAL: Ignorar cualquier interacción AJAX marcada con data-ajax-*
    // Esto hace escalable el sistema para cualquier módulo que use AJAX
    if (
        $this.attr("data-ajax-sort") ||
        $this.attr("data-ajax-filter") ||
        $this.attr("data-ajax-action") ||
        $this.attr("data-ajax-link") ||
        $this.closest("[data-ajax-container]").length > 0
    ) {
        return; // No ejecutar limpieza para interacciones AJAX
    }

    // Detectar logout específicamente
    const isLogout =
        (formAction && formAction.includes("/logout")) ||
        (href && href.includes("/logout")) ||
        text.includes("cerrar sesión") ||
        text.includes("logout") ||
        text.includes("salir");

    // Detectar navegación fuera de la página actual (pero no enlaces AJAX)
    const isNavigation =
        href &&
        href !== "#" &&
        !href.startsWith("javascript:") &&
        (href.startsWith("http") ||
            text.includes("cancelar") ||
            text.includes("regresar") ||
            text.includes("volver"));

    if (isLogout || isNavigation) {
        //console.log(
        //     isLogout ? "🚪 Logout detectado" : "🔗 Navegación detectada",
        //     "- ejecutando limpieza preventiva"
        // );
        executeImediateCleanup();
    }
});

// Limpieza al detectar inactividad de la pestaña
document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
        //console.log("👁️ Pestaña oculta, ejecutando limpieza");
        executeImediateCleanup();
    }
});

// Función de limpieza inmediata
function executeImediateCleanup() {
    if (window.uploadedTempImages && window.uploadedTempImages.length > 0) {
        const formSubmitted =
            sessionStorage.getItem("formSubmitted") === "true";
        if (!formSubmitted) {
            //console.log(
            //     "� Ejecutando limpieza inmediata de",
            //     window.uploadedTempImages.length,
            //     "imágenes"
            // );

            window.uploadedTempImages.forEach((img) => {
                if (img.filename) {
                    deleteTempImage(img.filename);
                }
            });

            // Limpiar el array inmediatamente
            window.uploadedTempImages = [];
        }
    }
}

// Verificación periódica y limpieza de localStorage (cada 15 segundos)
setInterval(function () {
    const pending = localStorage.getItem("pendingCleanup");
    if (pending) {
        try {
            const data = JSON.parse(pending);
            // Si han pasado más de 30 segundos, ejecutar limpieza
            if (Date.now() - data.timestamp > 30000) {
                //console.log("⏰ Limpieza periódica activada");
                data.images.forEach((filename) => {
                    if (filename) {
                        deleteTempImage(filename);
                    }
                });
                localStorage.removeItem("pendingCleanup");
            }
        } catch (e) {
            //console.warn("Error procesando limpieza pendiente:", e);
            localStorage.removeItem("pendingCleanup");
        }
    }
}, 15000);

// Limpieza al cargar la página (sesiones anteriores)
$(document).ready(function () {
    // Verificar limpieza pendiente de sesiones anteriores
    const pending = localStorage.getItem("pendingCleanup");
    if (pending) {
        try {
            const data = JSON.parse(pending);
            ////console.log("🔄 Procesando limpieza pendiente de sesión anterior");
            data.images.forEach((filename) => {
                if (filename) {
                    deleteTempImage(filename);
                }
            });
            localStorage.removeItem("pendingCleanup");
        } catch (e) {
            //console.warn("Error en limpieza de sesión anterior:", e);
            localStorage.removeItem("pendingCleanup");
        }
    }

    // Limpiar cualquier estado previo
    sessionStorage.removeItem("formSubmitted");
});

// Marcar formulario como enviado (imágenes permanentes)
$(document).on("submit", "form", function () {
    //console.log("📝 ✅ FORMULARIO ENVIADO - Imágenes ahora son permanentes");
    sessionStorage.setItem("formSubmitted", "true");
    localStorage.removeItem("pendingCleanup");
    window.uploadedTempImages = [];
});

// Debug: Mostrar estado de imágenes temporales
setInterval(function () {
    if (window.uploadedTempImages && window.uploadedTempImages.length > 0) {
        //console.log(
        //     "📊 Imágenes temporales actuales:",
        //     window.uploadedTempImages.length
        // );
    }
}, 10000); // Cada 10 segundos

// Agregar estilos CSS optimizados para la previsualización de Dropzone (reducido a ~15 líneas)
$(function () {
    const dropzoneCSS = `
        <style>
            .dz-custom-preview { max-width: 200px; margin: 10px auto; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1); background: #f8f9fa; padding: 12px; position: relative; }
            .dz-custom-preview:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.15); }
            .dz-custom-image { width: 180px; height: 140px; border-radius: 6px; overflow: hidden; margin: 0 auto; background: #e9ecef; position: relative; }
            .dz-custom-thumbnail { width: 100%; height: 100%; object-fit: cover; display: block; image-rendering: -webkit-optimize-contrast; image-rendering: crisp-edges; } /* Mejora renderizado */
            .dz-custom-progress { position: absolute; bottom: 0; left: 0; right: 0; height: 4px; background: rgba(0,0,0,0.1); border-radius: 0 0 6px 6px; }
            .dz-custom-upload { display: block; height: 100%; background: #007bff; border-radius: inherit; transition: width 0.3s ease; }
            .dz-custom-details { text-align: center; margin-top: 8px; }
            .dz-custom-filename { font-size: 13px; color: #333; font-weight: 500; margin-bottom: 2px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
            .dz-custom-size { font-size: 11px; color: #666; }
            .dz-custom-success, .dz-custom-error { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); opacity: 0; transition: opacity 0.3s ease; }
            .dz-custom-icon { font-size: 32px; color: #28a745; }
            .dz-custom-error .dz-custom-icon { color: #dc3545; }
            .dz-success .dz-custom-success, .dz-error .dz-custom-error { opacity: 1; }
            @media (max-width: 768px) { .dz-custom-preview { max-width: 160px; padding: 10px; } .dz-custom-image { width: 140px; height: 110px; } }
        </style>
    `;
    $("head").append(dropzoneCSS);
});

/*###DROPZONE###*/
$(function () {
    //console.log("✅ Tránsito de Cota JS custom cargado correctamente");

    // Inicializar plugin BlockUI
    initializeBlockUI();

    // Disable ALL conflicting scroll handlers
    $(document).off("click", 'a[href*="#"]'); // Remove any existing handlers
    $(".scrollnav").off("click"); // Remove navScroll handlers
    $('a[href*="#"]').off("click"); // Remove all existing click handlers

    // Handle anchor links to prevent errors and fix scroll margin
    $(document).on("click", 'a[href*="#"]', function (e) {
        // Stop all other event handlers (including navScroll)
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        var href = $(this).attr("href");

        // Check if it's a hash-only link or contains route + hash
        if (href.indexOf("#") !== -1) {
            var parts = href.split("#");
            var hash = parts[1];
            var route = parts[0];

            // If there's a route part and we're not on that page
            if (
                route &&
                route !== "" &&
                !window.location.href.includes(route)
            ) {
                // Let browser handle the redirect normally
                window.location.href = href;
                return false;
            }

            // Check if target exists on current page
            var $target = $("#" + hash);
            if ($target.length === 0) {
                // Element not found, redirect to home with hash
                window.location.href = href;
                return false;
            } else {
                // Element found, handle smooth scroll
                //console.log("🎯 Navegando a sección:", hash);

                // Usar scrollIntoView nativo para evitar conflictos
                setTimeout(() => {
                    const element = document.getElementById(hash);
                    if (element) {
                        // Calcular posición manualmente
                        const headerHeight =
                            document.querySelector(".header")?.offsetHeight ||
                            80;
                        const elementTop = element.offsetTop;
                        const scrollToPosition = Math.max(
                            0,
                            elementTop - headerHeight - 40
                        );

                        //console.log(
                        //     "📍 Elemento encontrado. Top:",
                        //     elementTop,
                        //     "ScrollTo:",
                        //     scrollToPosition
                        // );

                        // Scroll suave nativo con recálculo
                        window.scrollTo({
                            top: scrollToPosition,
                            behavior: "smooth",
                        });

                        // Recalcular después de 500ms por si hay contenido dinámico
                        setTimeout(() => {
                            const updatedTop = element.offsetTop;
                            const updatedPosition = Math.max(
                                0,
                                updatedTop - headerHeight - 40
                            );
                            if (
                                Math.abs(updatedPosition - scrollToPosition) >
                                50
                            ) {
                                // //console.log(
                                //     "🔄 Recalculando posición:",
                                //     updatedPosition
                                // );
                                window.scrollTo({
                                    top: updatedPosition,
                                    behavior: "smooth",
                                });
                            }
                        }, 500);
                    }
                }, 10); // Micro delay para evitar conflictos

                return false;
            }
        }
    });

    // Handle hash on page load (for direct links with anchors)
    if (window.location.hash) {
        setTimeout(() => {
            var hash = window.location.hash.substring(1); // Remover el #
            const element = document.getElementById(hash);

            if (element) {
                // //console.log("🔄 Carga inicial con hash:", hash);

                // Calcular posición usando JavaScript nativo
                const headerHeight =
                    document.querySelector(".header")?.offsetHeight || 80;
                const elementTop = element.offsetTop;
                const scrollToPosition = Math.max(
                    0,
                    elementTop - headerHeight - 40
                );

                // //console.log(
                //     "📍 Elemento inicial encontrado. Top:",
                //     elementTop,
                //     "ScrollTo:",
                //     scrollToPosition
                // );

                // Scroll directo sin animación para carga inicial
                window.scrollTo({
                    top: scrollToPosition,
                    behavior: "smooth",
                });
            }
        }, 1000); // Delay mayor para asegurar renderizado completo
    }

    // Función para aplicar el padding correcto al home SOLO en la página principal
    function applyHomePadding() {
        // Solo aplicar si estamos en la página home (/) Y existe el elemento #home
        if (window.location.pathname === "/" && $("#home").length > 0) {
            var headerHeight = $(".header").outerHeight() || 80;
            $("#home").css("padding-top", headerHeight + "px");
            // //console.log("Padding applied to #home:", headerHeight + "px");
        }
    }

    // Solo aplicar padding si estamos en la página home
    if (window.location.pathname === "/") {
        // Aplicar padding correcto en la carga inicial
        setTimeout(() => {
            applyHomePadding();
        }, 100);

        // También aplicar después de que las imágenes se carguen
        $(window).on("load", function () {
            applyHomePadding();
        });

        // Aplicar padding también cuando se redimensiona la ventana (solo en home)
        $(window).on("resize", function () {
            applyHomePadding();
        });
    }

    // Agrega aquí el código para reaplicar padding después del scroll
    $(document).on("click", '.dropdown-content li a[href*="#"]', function (e) {
        // Después del scroll, reaplica el padding del dropdown
        setTimeout(() => {
            $(".large-dropdown").css({
                padding: "14px 16px",
                "min-width": "220px",
            });
        }, 500); // Espera a que termine el scroll
    });

    // Para mantener el margen de home cuando se redirecciona (solo ejecutar en home)
    if ($("#home").length > 0 && window.location.pathname === "/") {
        applyHomePadding();
    }

    // Función debug mejorada
    window.debugScrollTargets = function () {
        const targets = ["project", "community", "ai-faq"];
        const headerHeight =
            document.querySelector(".header")?.offsetHeight || 80;
        // //console.log("🔍 Debug de elementos objetivo:");
        // //console.log("  Header height:", headerHeight);
        // //console.log("  Current scroll position:", window.scrollY);

        targets.forEach((id) => {
            const element = document.getElementById(id);
            const exists = element !== null;
            const top = exists ? element.offsetTop : "N/A";
            const calculatedScroll = exists
                ? Math.max(0, element.offsetTop - headerHeight - 40)
                : "N/A";
            // //console.log(
            //     `  #${id}: Existe=${exists}, Top=${top}, ScrollTo=${calculatedScroll}`
            // );
        });
    };

    // Función para navegar manualmente (debug)
    window.debugScrollTo = function (targetId) {
        const element = document.getElementById(targetId);
        if (element) {
            const headerHeight =
                document.querySelector(".header")?.offsetHeight || 80;
            const scrollToPosition = Math.max(
                0,
                element.offsetTop - headerHeight - 40
            );
           // //console.log(`🎯 Debug scroll a #${targetId}:`, scrollToPosition);
            window.scrollTo({
                top: scrollToPosition,
                behavior: "smooth",
            });
        } else {
            //console.warn(`Elemento #${targetId} no encontrado`);
        }
    };

    // //console.log(
    //     '🔧 Debug functions: debugScrollTargets() y debugScrollTo("id")'
    // );

    // Override tardío para interceptar plugins que se cargan después
    setTimeout(() => {
        // //console.log("🔥 Aplicando override tardío");

        // Remover TODOS los handlers de enlaces con hash
        $('a[href*="#"]').off("click");
        $(".scrollnav a").off("click");

        // Aplicar nuestro handler con mayor prioridad
        $('a[href*="#"]').on("click.finalOverride", function (e) {
            const href = $(this).attr("href");

            if (href && href.includes("#")) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();

                const hashMatch = href.match(/#([^#]*)$/);
                if (hashMatch) {
                    const hash = hashMatch[1];
                    const element = document.getElementById(hash);

                    if (element) {
                        //console.log("🎯 Override final navegando a:", hash);

                        const headerHeight =
                            document.querySelector(".header")?.offsetHeight ||
                            80;
                        const elementTop = element.offsetTop;
                        const scrollToPosition = Math.max(
                            0,
                            elementTop - headerHeight - 40
                        );

                        setTimeout(() => {
                            window.scrollTo({
                                top: scrollToPosition,
                                behavior: "smooth",
                            });

                            // Recalcular por contenido dinámico
                            setTimeout(() => {
                                const updatedTop = element.offsetTop;
                                const updatedPosition = Math.max(
                                    0,
                                    updatedTop - headerHeight - 40
                                );
                                if (
                                    Math.abs(
                                        updatedPosition - scrollToPosition
                                    ) > 50
                                ) {
                                    //console.log(
                                    //     "🔄 Override recalculando:",
                                    //     updatedPosition
                                    // );
                                    window.scrollTo({
                                        top: updatedPosition,
                                        behavior: "smooth",
                                    });
                                }
                            }, 500);
                        }, 50);
                    }
                }
                return false;
            }
        });
    }, 2000); // Se ejecuta 2 segundos después para interceptar todo

    // ..
});
// ...existing code...

/**
 * Plugin BlockUI para Tránsito de Cota
 * Sistema de superposición de carga fácil de usar
 */

function initializeBlockUI() {
    // Crear estructura HTML de BlockUI
    const blockUIHTML = `
    <div id="app-blocker" class="d-none">
      <div class="blocker-overlay"></div>
      <div class="blocker-content">
        <div class="spinner-container">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
          <div class="icon text-spinner">
              <span class="icon-wrap primary-icon3d">
                <i class="front-3d mdi mdi-car-search primary-icon3d"></i>
              </span>
          </div>
        </div>
        <div class="blocker-message">
          <p id="blocker-text" class="mt-3 text-white">Procesando solicitud...</p>
        </div>
      </div>
    </div>
  `;

    // Agregar al body si no existe
    if ($("#app-blocker").length === 0) {
        $("body").append(blockUIHTML);
    }

    // Objeto BlockUI global
    window.BlockUI = {
        /**
         * Mostrar superposición de carga
         * @param {string} message - Mensaje de carga personalizado
         * @param {string} type - Tipo de carga (default, success, warning, error)
         */
        show: function (message = "Procesando solicitud...", type = "default") {
            const blocker = $("#app-blocker");
            const text = $("#blocker-text");
            const spinner = $(".spinner-border");

            // Actualizar mensaje
            text.text(message);

            // Actualizar estilo del spinner según el tipo
            spinner.removeClass(
                "text-primary text-success text-warning text-danger"
            );
            switch (type) {
                case "success":
                    spinner.addClass("text-success");
                    break;
                case "warning":
                    spinner.addClass("text-warning");
                    break;
                case "error":
                    spinner.addClass("text-danger");
                    break;
                default:
                // Default styling
            }

            // Mostrar bloqueador con animación
            blocker.removeClass("d-none").addClass("show");
            $("body").addClass("blocked");

            //console.log("🔒 BlockUI: Mostrando -", message);
        },

        /**
         * Ocultar superposición de carga
         * @param {number} delay - Retraso antes de ocultar (milisegundos)
         * @param {string} targetSection - Selector de sección para scroll (opcional)
         */
        hide: function (delay = 0, targetSection = null) {
            setTimeout(() => {
                $("#app-blocker").removeClass("show").addClass("d-none");
                $("body").removeClass("blocked");

                // Realizar scroll suave después de ocultar BlockUI
                if (targetSection) {
                    this.smoothScrollTo(targetSection);
                }
            }, delay);
        },

        /**
         * Mostrar sección objetivo (remover d-none)
         * @param {string} targetSection - Selector de sección para mostrar
         */
        showTargetSection: function (targetSection) {
            if (targetSection) {
                const $target = $(targetSection);
                if ($target.length && $target.hasClass("d-none")) {
                    $target.removeClass("d-none");
                    //console.log(`👁️ Sección mostrada: ${targetSection}`);
                }
            }
        },

        smoothScrollTo: function (target) {
            const $target = $(target);

            if ($target.length) {
                // Calcular offset para el scroll
                const offset = $target.offset().top - 80; // 80px de padding superior

                // Scroll suave usando 'swing' (built-in jQuery easing)
                $("html, body").animate(
                    {
                        scrollTop: offset,
                    },
                    700,
                    "swing",
                    function () {
                        //console.log(`📍 Scroll completado a: ${target}`);

                        // Agregar efecto de highlight temporal
                        $target.addClass("highlight-section");
                        setTimeout(() => {
                            $target.removeClass("highlight-section");
                        }, 2000);
                    }
                );
            } else {
                //console.warn(`⚠️ Sección no encontrada: ${target}`);
            }
        },

        /**
         * Mostrar mensaje de éxito y ocultar después del retraso
         * @param {string} message - Mensaje de éxito
         * @param {number} duration - Duración para mostrar (milisegundos)
         * @param {string} targetSection - Selector de sección para scroll (opcional)
         */
        success: function (
            message = "¡Operación exitosa!",
            duration = 2000,
            targetSection = null
        ) {
            // Primero mostrar la sección objetivo (remover d-none)
            this.showTargetSection(targetSection);

            // Luego mostrar el mensaje de éxito
            this.show(message, "success");

            // Finalmente ocultar y hacer scroll
            this.hide(duration, targetSection);
        },

        /**
         * Mostrar mensaje de error y ocultar después del retraso
         * @param {string} message - Mensaje de error
         * @param {number} duration - Duración para mostrar (milisegundos)
         * @param {string} targetSection - Selector de sección para scroll (opcional)
         */
        error: function (
            message = "Ha ocurrido un error",
            duration = 3000,
            targetSection = null
        ) {
            // Mostrar sección objetivo incluso en error
            this.showTargetSection(targetSection);

            this.show(message, "error");
            this.hide(duration, targetSection);
        },

        /**
         * Mostrar mensaje de advertencia y ocultar después del retraso
         * @param {string} message - Mensaje de advertencia
         * @param {number} duration - Duración para mostrar (milisegundos)
         * @param {string} targetSection - Selector de sección para scroll (opcional)
         */
        warning: function (
            message = "Advertencia",
            duration = 2500,
            targetSection = null
        ) {
            // Mostrar sección objetivo
            this.showTargetSection(targetSection);

            this.show(message, "warning");
            this.hide(duration, targetSection);
        },

        /**
         * Verificar si BlockUI está actualmente activo
         * @returns {boolean}
         */
        isActive: function () {
            return $("#app-blocker").hasClass("show");
        },

        /**
         * Alternar estado de BlockUI
         * @param {string} message - Mensaje a mostrar si se activa
         */
        toggle: function (message = "Procesando...") {
            if (this.isActive()) {
                this.hide();
            } else {
                this.show(message);
            }
        },
    };

    // Wrapper de plugin jQuery actualizado
    $.fn.blockUI = function (options = {}) {
        const settings = $.extend(
            {
                message: "Procesando...",
                type: "default",
                action: "show",
                targetSection: null,
            },
            options
        );

        switch (settings.action) {
            case "hide":
                BlockUI.hide(settings.delay, settings.targetSection);
                break;
            case "success":
                BlockUI.success(
                    settings.message,
                    settings.duration,
                    settings.targetSection
                );
                break;
            case "error":
                BlockUI.error(
                    settings.message,
                    settings.duration,
                    settings.targetSection
                );
                break;
            case "warning":
                BlockUI.warning(
                    settings.message,
                    settings.duration,
                    settings.targetSection
                );
                break;
            default:
                BlockUI.show(settings.message, settings.type);
        }

        return this; // Habilitar encadenamiento
    };

    // Auto-ocultar BlockUI si el usuario hace clic fuera (opcional)
    $(document).on("click", "#app-blocker .blocker-overlay", function () {
        // Descomentar la siguiente línea si quieres hacer clic para descartar
        // BlockUI.hide();
    });

    // Atajo de teclado para ocultar BlockUI (tecla ESC)
    $(document).on("keydown", function (e) {
        if (e.key === "Escape" && BlockUI.isActive()) {
            BlockUI.hide();
        }
    });

    //console.log("🎯 Plugin BlockUI inicializado y listo!");
}

/**
 * Configuración AJAX con integración automática de BlockUI
 */

// Configurar CSRF token para todas las peticiones AJAX de jQuery
$.ajaxSetup({
    headers: {
        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
});

$(document).ajaxStart(function () {
    // Auto-mostrar BlockUI en peticiones AJAX (opcional)
    // BlockUI.show('Cargando datos...');
});

$(document).ajaxStop(function () {
    // Auto-ocultar BlockUI cuando AJAX se completa (opcional)
    // BlockUI.hide(300);
});

$(document).ajaxError(function (event, xhr, settings, error) {
    // Auto-mostrar error en fallo de AJAX
    BlockUI.error("Error al cargar los datos");
    console.error("AJAX Error:", error);
});

///tiempo de alertas

$(document).ajaxError(function (event, xhr, settings, error) {
    // Auto-mostrar error en fallo de AJAX
    BlockUI.error("Error al cargar los datos");
    console.error("AJAX Error:", error);
});

// Configuración global para alertas de éxito (sesiones flash de Laravel)
$(function () {
    // Cambiado de $(document).ready() para evitar deprecation warning
    // Configuración global: duración en ms (puedes cambiar aquí para afectar todas las alertas)
    const ALERT_DURATION = 5000; // 5 segundos (global para todas las alertas de éxito)

    // Buscar y ocultar automáticamente todas las alertas de éxito
    $(".alert-success").each(function () {
        const alertElement = $(this);

        setTimeout(function () {
            alertElement.fadeOut(500, function () {
                alertElement.remove(); // Opcional: remover del DOM
            });
        }, ALERT_DURATION);
    });
});

/**
 * Video institucional con autoplay y controles
 * @author carlos rodriguez
 * @since 2025
 */
$(function () {
    const videoElement = document.getElementById("institutional_video");

    if (videoElement) {
        // Asegurar reproducción en dispositivos móviles
        videoElement.setAttribute("playsinline", "true");
        videoElement.setAttribute("webkit-playsinline", "true");

        // Intentar reproducir automáticamente cuando el video esté listo
        videoElement.addEventListener("loadeddata", function () {
            const playPromise = videoElement.play();

            if (playPromise !== undefined) {
                playPromise.catch((error) => {
                    //console.log(
                    //     "⚠️ Autoplay bloqueado por el navegador:",
                    //     error
                    // );
                    // Si falla el autoplay, el usuario podrá usar los controles
                });
            }
        });

        //console.log("🎬 Video institucional con controles inicializado");
    }
});

// === reCAPTCHA v3: Función global para generar token ===
window.generarTokenRecaptcha = async function () {
    const siteKeyMeta = document.head.querySelector(
        'meta[name="recaptcha-key"]'
    );
    if (!siteKeyMeta) {
        console.warn("⚠️ reCAPTCHA site key no encontrado");
        return null;
    }

    const siteKey = siteKeyMeta.content;

    return new Promise((resolve, reject) => {
        grecaptcha.ready(function () {
            grecaptcha
                .execute(siteKey, { action: "submit" })
                .then(function (token) {
                    resolve(token);
                })
                .catch(function (error) {
                    console.error("Error generando token reCAPTCHA:", error);
                    reject(error);
                });
        });
    });
};
